import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import login from '@/components/login'
import exit from '@/components/exit'
import wallet_log from '@/components/wallet_log'
import createOrder from '@/components/createOrder'
import openCreateOrder from '@/components/openCreateOrder'
import orderDetail from '@/components/orderDetail'
import assignationManagement from '@/components/assignationManagement'
import car from '@/components/car'
import lineItem from '@/components/lineItem'
import refuelingpoint from '@/selfhelp/refuelingpoint'
import therefuel from '@/selfhelp/therefuel'
import siteList from '@/components/siteList'
import location from '@/components/location'
import productList from '@/components/productList'
import productDetail from '@/components/productDetail'
import productPay from '@/components/productPay'
import billList from '@/components/billList'
import orderList from '@/components/orderList'
import foodCode from '@/components/foodCode'
import container_yard_login from '@/components/container-yard/login'
import container_yard_home from '@/components/container-yard/home'
import container_yard_in from '@/components/container-yard/in'
import container_yard_out from '@/components/container-yard/out'
import container_yard_search from '@/components/container-yard/search'
import container_yard_bill from '@/components/container-yard/bill'
import container_yard_billList from '@/components/container-yard/billList'
import container_yard_billInfo from '@/components/container-yard/billInfo'
import container_yard_pay from '@/components/container-yard/pay'
import box_manage_login from '@/components/box-manage/login'
import box_manage_home from '@/components/box-manage/home'
import box_manage_in from '@/components/box-manage/in'
import box_manage_out from '@/components/box-manage/out'
import box_manage_form from '@/components/box-manage/form'
import urea_qrcode from '@/components/urea/qrcode'
import urea_orderResult from '@/components/urea/orderResult'
import putbox_order from '@/components/putbox/order'
import subscribe from '@/components/subscribe'
import yunfeng_order from '@/components/yunfeng/order'
import yunfeng_therefuel from '@/components/yunfeng/therefuel'
import pre_record_home from '@/components/pre-record/home'
import pre_record_input from '@/components/pre-record/input'
import device_order from '@/components/device/order'
import device_orderResult from '@/components/device/orderResult'

Vue.use(Router)

const myRouter = new Router({
    mode: 'hash',
    routes: [
        {path: '/', name: 'home', component: home},
        {path: '/login', name: 'login', component: login},
        {path: '/sitelist', name: 'siteList', component: siteList},
        {path: '/location', name: 'location', component: location},
        {path: '/exit', name: 'exit', component: exit},
        {path: '/wallet_log', name: 'wallet_log', component: wallet_log},
        {path: '/createOrder/:id', name: 'createOrder', component: createOrder},
        {path: '/openCreateOrder/:id', name: 'openCreateOrder', component: openCreateOrder},
        {path: '/orderDetail/:order_id', name: 'orderDetail', component: orderDetail},
        {path: "/assignationManagement/:card_obj", name: "assignationManagement", component: assignationManagement},
        {path: "/lineItem", name: "lineItem", component: lineItem},
        {path: "/refuelingpoint/:tankernum", name: "refuelingpoint", component: refuelingpoint},
        {path: "/therefuel/:facility", name: "therefuel", component: therefuel},
        {path: "/car", name: "car", component: car},
        {path: "/product/list", name: "productList", component: productList},
        {path: "/product/detail/:id", name: "productDetail", component: productDetail},
        {path: "/product/pay/:id", name: "productPay", component: productPay},
        {path: "/billList", name: "billList", component: billList},
        {path: "/order/list", name: "orderList", component: orderList},
        {path: "/foodCode", name: "foodCode", component: foodCode},
        {path: "/container-yard/login", name: "container_yard_login", component: container_yard_login},
        {path: "/container-yard/home", name: "container_yard_home", component: container_yard_home},
        {path: "/container-yard/in", name: "container_yard_in", component: container_yard_in},
        {path: "/container-yard/out", name: "container_yard_out", component: container_yard_out},
        {path: "/container-yard/search", name: "container_yard_search", component: container_yard_search},
        {path: "/container-yard/bill", name: "container_yard_bill", component: container_yard_bill},
        {path: "/container-yard/billList", name: "container_yard_billList", component: container_yard_billList},
        {path: "/container-yard/billInfo/:id", name: "container_yard_billInfo", component: container_yard_billInfo},
        {path: "/container-yard/pay", name: "container_yard_pay", component: container_yard_pay},
        {path: "/box-manage/login", name: "box_manage_login", component: box_manage_login},
        {path: "/box-manage/home", name: "box_manage_home", component: box_manage_home},
        {path: "/box-manage/in", name: "box_manage_in", component: box_manage_in},
        {path: "/box-manage/out", name: "box_manage_out", component: box_manage_out},
        {path: "/box-manage/form", name: "box_manage_form", component: box_manage_form},
        {path: "/urea/qrcode/:imei", name: "urea_qrcode", component: urea_qrcode},
        {path: "/urea/orderResult/:order_id", name: "urea_orderResult", component: urea_orderResult},
        {path: "/putbox/order", name: "putbox_order", component: putbox_order},
        {path: "/subscribe", name: "subscribe", component: subscribe},
        {path: "/yunfeng/order/:gun_num", name: "yunfeng_order", component: yunfeng_order},
        {path: "/yunfeng/therefuel/:facility", name: "yunfeng_therefuel", component: yunfeng_therefuel},
        {path: "/pre-record/home", name: "pre_record_home", component: pre_record_home},
        {path: "/pre-record/input", name: "pre_record_input", component: pre_record_input},
        {path: "/device/order/:imei", name: "device_order", component: device_order},
        {path: "/device/orderResult/:order_id", name: "device_orderResult", component: device_orderResult},
    ]
});

myRouter.beforeEach((to, from, next) => {
    if (to.query.abc) {
        next();
        return;
    }
    ;
    if (from.query.abc) {
        let toQuery = JSON.parse(JSON.stringify(to.query));
        toQuery.abc = from.query.abc;
        next({
            path: to.path,
            query: toQuery
        })
    } else {
        to.query.abc = 123
        next()
    }
});
export default myRouter



// WEBPACK FOOTER //
// ./src/router/index.js